import { useState, type ReactNode } from 'react';

export const Overlay = ({
    title,
    onClose,
    children,
    footer,
}: {
    title: string;
    onClose: () => void;
    children: ReactNode;
    footer: ReactNode;
}) => (
    <div className="modal d-block" tabIndex={-1} style={{ background: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg rounded-4">
                <div className="modal-header px-4 py-3 border-bottom d-flex justify-content-between align-items-center">
                    <h5 className="modal-title font-16 font-600 text-dark-blue">{title}</h5>
                    <button type="button" className="btn-close shadow-none" onClick={onClose}></button>
                </div>
                <div className="modal-body p-4">{children}</div>
                <div className="modal-footer px-4 py-3 border-top d-flex justify-content-end gap-2">{footer}</div>
            </div>
        </div>
    </div>
);

export const useSave = (fn: () => Promise<any>, onDone: () => void) => {
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const run = async () => {
        setSaving(true);
        setError(null);
        try {
            await fn();
            onDone();
        } catch (e: any) {
            setError(e?.response?.data?.error?.message || e?.message || 'Action failed.');
            setSaving(false);
        }
    };
    return { saving, error, run };
};
